export default __webpack_public_path__ + "static/media/webpot.77a03afb.png";